import React from 'react';
import PropTypes from 'prop-types';
import tldToCountryCode from '@hydra/utils/tldToCountryCode';
import MapSvg from './WorldMapSvg';

import { hslToRgb } from '@hydra/utils/colors';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    width: '100%'
  },
  svg: {
    fill: theme.palette.secondary.light,
    display: 'block',
    width: '100%',
    height: 'auto'
  }
}));

const BASE_COLOR = { // $success as hsl
  hue: 207 / 360,
  saturation: 0.56,
  light: 0.5
};

const MAX_LIGHTNESS = 0.8;
const MORE_LIGHTNESS = 0.7;
const MEDIUM_LIGHTNESS = 0.6;
const MIN_LIGHTNESS = 0.5;

export const WorldMap = props => {
  const classes = useStyles();
  const {
    highlights = [],
    baseColor = BASE_COLOR
  } = props;

  const mapCountryCodeToMapId = code => tldToCountryCode(code);

  const blueValue = (index) => {
    switch (index) {
      case 0:
        return MIN_LIGHTNESS;
      case 1:
        return MEDIUM_LIGHTNESS;
      case 2:
        return MORE_LIGHTNESS;
      default:
        return MAX_LIGHTNESS;
    }
  };

  const makeStyles = highlights => {
    return highlights
      .reduce(
        (styles, { country, value }, index) => {
          const { red, green, blue } = hslToRgb(
            baseColor.hue,
            baseColor.saturation,
            blueValue(index)
          );
          return {
            ...styles,
            [mapCountryCodeToMapId(country)]: {
              fill: `rgb(${red}, ${green}, ${blue})`
            }
          };
        },
        {}
      );
  };

  const mapStyles = highlights.length > 0
    ? makeStyles(highlights)
    : {};

  return (
    <div className={classes.root}>
      <MapSvg className={classes.svg} style={mapStyles} />
    </div>
  );
};

WorldMap.propTypes = {
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      country: PropTypes.string,
      value: PropTypes.number
    })
  ),
  // All baseColor attributes must be scaled at [0..1]
  baseColor: PropTypes.shape({
    hue: PropTypes.number,
    saturation: PropTypes.number,
    light: PropTypes.number
  })
};

export default WorldMap;
